import ChartAPI from "../../apps/common/chart-api";

// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});

export default {
  namespaced: true,
  state: {
    cloaded: false,
    loading: false,
    fullChartItems: null,
    fullChartFields: null,
    wordstatReport: [],
    wordstatPeriod: JSON.parse(localStorage.getItem("wordstatPeriod")) || "WEEK",
    wordstatBrand: JSON.parse(localStorage.getItem("wordstatBrand")) !== null ? JSON.parse(localStorage.getItem("wordstatBrand")) : true,
    wordstatCategory: JSON.parse(localStorage.getItem("wordstatCategory")) !== null ? JSON.parse(localStorage.getItem("wordstatCategory")) : true,
    wordstatCombined: JSON.parse(localStorage.getItem("wordstatCombined")) !== null ? JSON.parse(localStorage.getItem("wordstatCombined")) : true,
  },
  actions: {
    async fetchWordstat({ commit, dispatch, getters, rootGetters }) {
      dispatch("filters/initSettings", null, { root: true });
      // НЕ перезаписываем фильтры - используем сохраненные значения
      // commit("updateWordstatBrand", true);        // Убрали
      // commit("updateWordstatCategory", true);     // Убрали
      // commit("updateWordstatCombined", true);     // Убрали
      commit("updateLoaded", false);
      commit("updateLoading", true);
      commit("updateFullChartFields", null);
      commit("updateFullChartItems", null);
      let studObj = new ChartAPI();
      let jsonOurResponse = await studObj.sendRequest(
        "getWordstat",
        rootGetters["currentProjectId"],
        getters["wordstatDownloadLink"]
      );
      if (jsonOurResponse["advertisers"].length) {
        commit("updateWordstatReport", jsonOurResponse);
        commit("updateLoaded", true);
      } else {
        commit("updateWordstatReport", []);
        commit("updateLoaded", false);
      }
      commit("updateLoading", false);
      return jsonOurResponse;
    },
    async selectPeriodType(
      { commit, getters, rootGetters, dispatch },
      wordstatPeriod
    ) {
      commit("updateWordstatPeriod", wordstatPeriod);
    },

    selectWordstatBrand({ commit }, wordstatBrand) {
      commit("updateWordstatBrand", wordstatBrand);
    },

    selectWordstatCategory({ commit }, wordstatCategory) {
      commit("updateWordstatCategory", wordstatCategory);
    },

    selectWordstatCombined({ commit }, wordstatCombined) {
      commit("updateWordstatCombined", wordstatCombined);
    },

    selectFullChartFields({ commit }, fullChartFields) {
      commit("updateFullChartFields", fullChartFields);
    },

    selectFullChartItems({ commit }, fullChartItems) {
      commit("updateFullChartItems", fullChartItems);
    },
  },
  mutations: {
    updateLoaded(state, cloaded) {
      state.cloaded = cloaded;
    },
    updateLoading(state, loading) {
      state.loading = loading;
    },
    updateWordstatReport(state, wordstatReport) {
      state.wordstatReport = wordstatReport;
    },
    updateWordstatPeriod(state, wordstatPeriod) {
      state.wordstatPeriod = wordstatPeriod;
      localStorage.setItem("wordstatPeriod", JSON.stringify(wordstatPeriod));
    },
    updateWordstatBrand(state, wordstatBrand) {
      state.wordstatBrand = wordstatBrand;
      localStorage.setItem("wordstatBrand", JSON.stringify(wordstatBrand));
    },
    updateWordstatCategory(state, wordstatCategory) {
      state.wordstatCategory = wordstatCategory;
      localStorage.setItem("wordstatCategory", JSON.stringify(wordstatCategory));
    },
    updateWordstatCombined(state, wordstatCombined) {
      state.wordstatCombined = wordstatCombined;
      localStorage.setItem("wordstatCombined", JSON.stringify(wordstatCombined));
    },
    updateFullChartFields(state, fullChartFields) {
      state.fullChartFields = fullChartFields;
    },
    updateFullChartItems(state, fullChartItems) {
      state.fullChartItems = fullChartItems;
    },
  },
  getters: {
    wordstatPeriod(state) {
      return state.wordstatPeriod;
    },

    wordstatDownloadLink(state, getters, rootState, rootGetters) {
      let wordstatLink = "/?" + rootGetters["filters/dateRangeParam"];
      
      // Добавляем фильтр по устройствам
      if (rootGetters["filters/deviceTypesParam"]) {
        wordstatLink += rootGetters["filters/deviceTypesParam"];
      }
      
      // Добавляем фильтр по ключевым словам
      if (rootGetters["filters/keywordsParam"]) {
        wordstatLink += rootGetters["filters/keywordsParam"];
      }
      
      // Добавляем фильтр по географии
      if (rootGetters["filters/geoLocationsParam"]) {
        wordstatLink += rootGetters["filters/geoLocationsParam"];
      }
      
      if (state.wordstatPeriod === "MONTH") {
        wordstatLink += "&period=MONTH";
      } else {
        wordstatLink += "&period=WEEK";
      }
      return wordstatLink;
    },

    cloaded(state) {
      return state.cloaded;
    },

    loading(state) {
      return state.loading;
    },

    wordstatReport(state) {
      return state.wordstatReport;
    },

    getWordstatBrand(state) {
      return state.wordstatBrand;
    },

    getWordstatCategory(state) {
      return state.wordstatCategory;
    },

    getWordstatCombined(state) {
      return state.wordstatCombined;
    },

    getFullChartFields(state) {
      return state.fullChartFields;
    },

    getFullChartItems(state) {
      return state.fullChartItems;
    },
  },
};
